import {type SagaIterator} from 'redux-saga';

import {fork, all} from 'redux-saga/effects';

import {homeTryOnAnalyticsSaga} from './analytics/analytics';
import {homeTryOnCartSaga} from './cart/cart';
import homeTryOnProductSaga from './homeTryOnProduct';
import homeTryOnCategorySaga from './homeTryOnCategory';

/**
 * Begin of saga
 */
export default function* homeTryOnSaga(): SagaIterator {
    yield all([
        fork(homeTryOnAnalyticsSaga),
        fork(homeTryOnCartSaga),
        fork(homeTryOnProductSaga),
        fork(homeTryOnCategorySaga),
    ]);
}
